import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  theme: 'default',
  apiKey: null,
};

export const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setTheme: (state, action) => {
      state.theme = action?.payload ?? null;
    },
    setApiKey: (state, action) => {
      state.apiKey = action?.payload ?? null;
    },
  },
});

export const { setTheme, setApiKey } = themeSlice.actions;

export default themeSlice.reducer;
